/**
 * Defines a map of flags currently in effect for the user.
 *
 * This is strongly typed, in comparison to the `IUserFlag` interface, which is
 * more generic.
 *
 * Use UseFlagsLookup to get one of these
 */
export interface IFlagsForUser {
  enhanced: boolean;
  isEnhancedForAccountId?: string;
  test?: number;
  newCustomer?: boolean | null;
  hasGymWaiver?: boolean;
  hideGymWaiverMessage?: boolean;
}

export enum WAIVER_STATE {
  VALID = 'valid',
  EXPIRING_SOON = 'expiring_soon',
  NOT_FOUND = 'not_found',
}

/**
 * The caller's profile as the tRPC layer sees it (ctx.user). Historically decoded out of the
 * Bruntwood token; since OKTA-6 it is what companion-auth's /api/user/me returns for the presented
 * credential, so it is live data and works for any token type. The name is kept to avoid churn.
 */
/**
 * Who is calling — all a request needs to be authorised. Comes from companion-auth's /api/whoami
 * (OKTA-6): one signature check, no profile. Anything a procedure needs beyond identity is a
 * separate profile fetch (see env/utils/callerProfile.ts), done only where needed.
 */
export interface ICallerIdentity {
  /** The user's email. */
  sub: string;
  /** 'bruntwood' for a legacy token, otherwise the provider's issuer URL. */
  issuer: string;
  /** Unix seconds; the identity may be trusted until then. */
  expiresAt: number;
}

export interface IProfileTokenPayload {
  sub: string;
  flags: IFlagsForUser;
  accountIds: {
    nexudusCoworker?: number;
    sfAccountId?: string;
  };
  gymWaiver?: 'expiring_soon' | 'valid' | 'not_found';
  gymWaiverExpiryDate?: string;
}
